/** 원. 소수점은 버린다 — 기성·계약 금액은 원 단위로 떨어진다. */
export function won(value: number | null | undefined): string {
  if (value === null || value === undefined) return '-';
  return `${Math.round(value).toLocaleString('ko-KR')}원`;
}

/** 백만원 단위. 계약금액처럼 자릿수가 길어 한눈에 안 들어오는 자리에 쓴다. */
export function millionWon(value: number | null | undefined): string {
  if (value === null || value === undefined) return '-';
  return `${Math.round(value / 1_000_000).toLocaleString('ko-KR')}백만원`;
}

/** `2026-09-08` → `9월 8일`. 올해가 아니면 연도를 붙인다. */
export function shortDate(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const thisYear = date.getFullYear() === new Date().getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return thisYear ? `${month}월 ${day}일` : `${date.getFullYear()}년 ${month}월 ${day}일`;
}

/** `2026-09-30T08:00:00Z` → `9월 30일 17:00`. 마감·현장설명회처럼 <b>시각까지</b> 봐야 하는 자리. */
export function shortDateTime(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  return `${shortDate(value)} ${hour}:${minute}`;
}

/**
 * 마감까지 남은 길이 — `3일 남음` · `5시간 남음` · `12분 남음`.
 *
 * <p><b>마감했는지는 판정하지 않는다.</b> 그것은 서버가 `closed` 로 답한 값이고(DOC-98 §4-1),
 * 여기는 남은 길이를 사람 말로 옮기기만 한다 — 두 곳이 판정하면 기기 시계가 틀어진 날 화면이
 * 「아직 넉넉하다」고 말하면서 서버는 거절한다.
 */
export function untilLabel(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '-';
  const target = new Date(value).getTime();
  if (Number.isNaN(target)) return '-';
  const minutes = Math.floor((target - Date.now()) / 60_000);
  if (minutes <= 0) return '곧 마감';
  if (minutes < 60) return `${minutes}분 남음`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}시간 남음`;
  return `${Math.floor(hours / 24)}일 남음`;
}

export function isoDate(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '-';
  return value.slice(0, 10);
}

/** `2026-09` → `2026년 9월` */
export function periodLabel(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '-';
  const [year, month] = value.split('-');
  if (year === undefined || month === undefined) return value;
  return `${year}년 ${Number(month)}월`;
}

export function fileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes}B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)}KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
}

export function percent(value: number | null | undefined): string {
  if (value === null || value === undefined) return '-';
  return `${value.toFixed(1)}%`;
}

/** `2026년 9월 10일 (목)` — 홈 인사말 밑의 날짜. front 의 같은 이름 함수와 같은 모양이다. */
export function shortDateWithWeekday(date: Date): string {
  const weekday = ['일', '월', '화', '수', '목', '금', '토'][date.getDay()] ?? '';
  return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 (${weekday})`;
}

/** 오늘 날짜를 `YYYY-MM-DD` 로. 입력 폼의 기본값. */
export function today(): string {
  return new Date().toISOString().slice(0, 10);
}
